var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.onShow)?_c('div',{staticClass:"login-container"},[_c('div',[_c('img',{attrs:{"src":require("../assets/Rateio_Indireto_Login.png"),"width":"136px","height":"200px"}}),_c('p'),_c('div',{attrs:{"id":"signin_button"}}),(_vm.error)?_c('p',{staticClass:"user-login__error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }